import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';
import colors from 'shared-tokens/utils/tokens/colors';

import { mainCls as baseCls } from '../style';

const brpM = createBreakpoint('m');

export const mainCls = `${baseCls}__hdr`;

export default {
  [mainCls]: {
    height: 48,
    minHeight: 48,
    zIndex: 3,
    [brpM]: {
      height: 60,
      minHeight: 60,
    },
  },
  [`${mainCls}__h100`]: {
    height: '100%',
    justifyContent: 'center',
    flexDirection: 'row-reverse',
    paddingLeft: '8px',
    [brpM]: {
      justifyContent: 'space-between',
      paddingLeft: 0,
      flexDirection: 'row',
    }
  },
  [`${mainCls}__ghost-el`]: {
    width: '48px',
    height: '100%',
    [brpM]: {
      display: 'none',
    },
  },
  [`${mainCls}__btn`]: {
    background: 'transparent',
    border: '0 none',
    '-webkit-tap-highlight-color': 'transparent',
  },
  [`${mainCls}__close`]: {
    // 'order': 2,
    position: 'relative',
    width: 48,
    textAlign: 'center',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-48px',
      width: 48,
      height: '100%',
      background:
        'linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);',
      zIndex: 1,
      pointerEvents: 'none',
    },
    [brpM]: {
      // order: 1,
      width: 240,
      paddingLeft: 32,
      textAlign: 'left',
    },
  },
  [`${mainCls}__closebtn`]: {
    '& svg path': {
      strokeWidth: 2,
    },
  },
  [`${mainCls}__ctn`]: {
    // 'order': 1,
    flex: '1 1 auto',
    paddingTop: 11,
    paddingBottom: 10,
    paddingLeft: 16,
    'clip-path': 'inset(0 0 10px 0)',
    '-webkit-clip-path': 'inset(0 0 10px 0)',
    maxWidth: 'calc(100vw - 48px)',
    overflowX: 'auto',
    overflowY: 'hidden',
    scrollbarColor: 'transparent transparent',

    '-webkit-overflow-scrolling': 'touch',
    scrollBehavior: 'smooth',

    '&::-webkit-scrollbar': {
      width: 0,
      height: 0,
      '-webkit-appearance': 'none',
      background: 'transparent',
      display: 'none',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 0,
      backgroundColor: 'transparent',
      boxShadow: '0 0 0 hsla(0, 0, 0, 0)',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '&::-moz-scrollbar': {
      display: 'none',
    },
    [brpM]: {
      // 'order': 2,
      paddingLeft: 0,
      paddingTop: 0,
      paddingBottom: 0,
      clipPath: 'inset(0 0 0 0)',
      'clip-path': 'inset(0 0 0 0)',
      maxWidth: 'none',
    },
  },
  [`${mainCls}__utils-title`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingRight: '8px',
    [brpM]: {
      paddingRight: 0,
    },
  },
  [`${mainCls}__utils`]: {
    display: 'none',
    [brpM]: {
      display: 'flex',
      flexDirection: 'row',
    },
  },
  [`${mainCls}__utilsbtn`]: {
    width: 24,
    height: 24,
    transition: createTransition(['color']),
    '& svg path': {
      strokeWidth: 1.2,
    },
    '&:hover': {
      color: `${colors.f0.rgba}!important`,
    },
  },
  [`${mainCls}__leadbtn`]: {
    width: 128,
    height: 32,
    lineHeight: '32px',
    border: '0 none',
    transition: createTransition(['background']),
    '&:hover': {
      background: '#A30000 !important',
    },
  },
  [`${mainCls}__btn-detail`]: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 4,
    border: '1px solid #D8DBDF',
    '&:hover': {
      borderColor: colors.secondary.rgba,
    },
  },
};
